import { NUMBER, SIGN, TIME } from '@/types/GeneralConstants'

class DateFormat {
  date: Date
  constructor (date: Date, isUTCDate: boolean = true) {
    this.date = new Date(date)
    if (isUTCDate) {
      const diffInMiliseconds = this.date.getTimezoneOffset() * 60 * 1000
      const currentMiliseconds = this.date.getTime()
      this.date = new Date(currentMiliseconds - diffInMiliseconds)
    }
  }
  /**
   * @returns the string format as 'dd/mm/yyyy'
   */
  toDateString (): string {
    const localFormat = this.date.toLocaleDateString('es-MX')
    const values = localFormat.split('/')
    values.forEach((part, index) => { values[index] = part.padStart(2, '0') })
    return values.join('/')
  }
  /**
   * @returns the string format as 'dd/mm/yyyy - hh:mm AM/PM'
   */
  toDateTimeString () {
    return `${this.toDateString()} - ${this.date.toLocaleTimeString()}`
  }
}

const DateUtils = {
  areDatesSameDay: function (date: Date, dateToCompare: Date) {
    return date.getFullYear() === dateToCompare.getFullYear() &&
      date.getMonth() === dateToCompare.getMonth() &&
      date.getDate() === dateToCompare.getDate()
  },
  isUTCFormat: function (string: String) {
    return string.endsWith('Z')
  },
  addZToDatetime: function (datetime: String) {
    return `${datetime}Z`
  },
  getTimezoneOffsetWithSignHHmm: function (): string {
    const today = new Date()
    const timeZoneOffsetInHours = today.getTimezoneOffset() / TIME.MINUTES_IN_AN_HOUR
    const timeZoneOffsetInMinutes = today.getTimezoneOffset() % TIME.MINUTES_IN_AN_HOUR
    const hoursPart = Math.abs(Math.ceil(timeZoneOffsetInHours)).toString().padStart(2, '0') // HH
    const minutesPart = Math.abs(timeZoneOffsetInMinutes).toString().padStart(2, '0') // mm
    const hoursAndMinutes = `${hoursPart}:${minutesPart}`
    return timeZoneOffsetInHours > NUMBER.ZERO
      ? `${SIGN.NEGATIVE}${hoursAndMinutes}`
      : `${SIGN.POSITIVE}${hoursAndMinutes}`
  },
  fromDatetimeInUTCToLocalFormat: function (datetimeInUTC: string /* ISO 8601 */): string {
    const datetimeUTC = this.isUTCFormat(datetimeInUTC) ? datetimeInUTC : this.addZToDatetime(datetimeInUTC)
    const date = new Date(datetimeUTC)
    return `${date.toLocaleDateString()}, ${date.toLocaleTimeString()}`
  },
  getTimeLapseDHMSFromMilliseconds (timeInMilliseconds: number): string {
    const durationInSec = (timeInMilliseconds % TIME.MILLISECONDS_IN_AN_MINUTE) / NUMBER.ONE_THOUSAND
    const durationInMinutes = (timeInMilliseconds % TIME.MILLISECONDS_IN_AN_HOUR) / TIME.MILLISECONDS_IN_AN_MINUTE
    const durationInHours = (timeInMilliseconds % TIME.MILLISECONDS_IN_A_DAY) / TIME.MILLISECONDS_IN_AN_HOUR
    const durationInDays = timeInMilliseconds / TIME.MILLISECONDS_IN_A_DAY

    const DaysHoursMinutesSeconds = []
    if (durationInDays >= NUMBER.ONE) DaysHoursMinutesSeconds.push(durationInDays.toFixed() + 'd')
    if (durationInHours >= NUMBER.ONE) DaysHoursMinutesSeconds.push(durationInHours.toFixed() + 'h')
    if (durationInMinutes >= NUMBER.ONE) DaysHoursMinutesSeconds.push(durationInMinutes.toFixed() + 'm')
    DaysHoursMinutesSeconds.push(durationInSec >= NUMBER.ONE
      ? durationInSec.toFixed() + 's'
      : DaysHoursMinutesSeconds.length <= 0 ? '< 0s' : '')

    return DaysHoursMinutesSeconds.join(' ')
  },
  differenceInMilliseconds (from: Date, to: Date): number {
    return to.getTime() - from.getTime()
  }
}

export default DateFormat
export { DateUtils }
